import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=bae76e72&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=bae76e72&prod&lang=scss&scoped=true"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=bae76e72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae76e72",
  null
  
)

export default component.exports